export const standardGrid = `---
subtitle: Heron Island Reef, 1998
subtitle: Same Transect, 2023
---
image: subway
  caption: 62% live coral cover, 214 fish species, complexity index 4.2/5. Photo: AIMS.
image: bahaus
  caption: 11% live coral cover, 134 fish species, complexity index 1.8/5. Photo: AIMS.
---
Five mass bleaching events between 1998 and 2023 struck this 50-metre transect as summer sea surface temperatures exceeded 27.5 C for prolonged periods. The fish community shifted from coral-dependent species to algae grazers, and structural complexity collapsed. Recovery between events was increasingly incomplete. (Hughes et al., Nature, 2018; AIMS, 2023)
-->
`